import {
  SET_TEACHERS,
  RESET_TEACHERS,
  CURRENT_TEACHER
} from "../constants/teachers"
import {
  propOr
} from "ramda"
import {
  TEACHER
} from "@/constants/userRoles"
import axios from "@/utils/axios"

const initialState = () => ({
  teachers: {
    results: []
  },
  currentTeacher: {}
})

const state = initialState()

const getters = {
  paginateTeachers: propOr({}, 'teachers'),
  currentTeacher: propOr({}, 'currentTeacher')
}

const actions = {
  getTeachers({ commit, dispatch }, { page = 1, search = null } = {}) {
    return dispatch('organization/_getCurrentOrganizationUsersPage', {
      page,
      roles: TEACHER,
      search
    }, { root: true })
      .then(response => commit(SET_TEACHERS, response.data))
  },
  reset({ commit }) {
    return commit(RESET_TEACHERS)
  },
  getTeacher({ dispatch }, { teacherId, organizationId }){
    return axios.get(`v1/organizations/${organizationId}/users/${teacherId}`)
      .then(response => dispatch('setCurrentTeacher', response.data))
  },
  setCurrentTeacher({ commit }, teacher) {
    return commit(CURRENT_TEACHER, teacher)
  }
}

const mutations = {
  [SET_TEACHERS](state, paginatedTeachers) {
    state.teachers = { ...paginatedTeachers }
  },
  [RESET_TEACHERS](state) {
    Object.assign(state, initialState())
  },
  [CURRENT_TEACHER](state, teacher) {
    state.currentTeacher = teacher
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
